export default {
  githubForkLink: "https://docasnyemail.sk",
  githubAriaLabel: "Vytvor si dočasný email na jeden klik",
  tweetMessage: "Vytvor si dočasný email na jeden klik",
  tweetDataUrl: "https://docasnyemail.sk",
  mainURL: "https://docasnyemail.sk",
  enabled: true
}



//////////////////
// WEBPACK FOOTER
// ./config/shareConfig.js
// module id = null
// module chunks = 